<div  [ngClass]="messageType === constants.SUCCESS ? 'alert-success': 'alert-danger'" class="alert  alert-dismissible fade show mt-3" role="alert">
    <strong id="videoTitle"></strong> <span id="message">{{message}} </span>
    <button (click)="closeAlert()" type="button" class="close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<!-- <div id="error-alert" class="alert alert-danger alert-dismissible fade show mt-3" role="alert">
    <span id="error-message"></span>
    <button (click)="closeErrorAlert()" type="button" class="close">
        <span aria-hidden="true">&times;</span>
    </button>
</div> -->